import React from 'react';
import cx from 'classnames';
import { Position, Toaster, Icon, Intent } from '@blueprintjs/core';
export const AppToaster = Toaster.create({
    className: 'error-toaster',
    position: Position.TOP,
    maxToasts: 5,
    usePortal: true,
});
export const displayError = ({ message, action, actionLabel, timeout = 10000, className = '', }) => {
    const addClassName = `${cx('client-error', className)}`;
    AppToaster.show({
        intent: Intent.DANGER,
        icon: React.createElement(Icon, { icon: "error" }),
        className: addClassName,
        message,
        timeout,
        action: typeof action !== 'undefined'
            ? {
                onClick: () => {
                    action();
                },
                text: typeof actionLabel !== 'undefined' ? actionLabel : '',
            }
            : undefined,
    });
};
export const displaySuccess = ({ message, action, actionLabel, timeout = 10000, className = '', }) => {
    const addClassName = `${cx('client-error', className)}`;
    AppToaster.show({
        intent: Intent.SUCCESS,
        icon: React.createElement(Icon, { icon: "tick" }),
        className: addClassName,
        message,
        action: typeof action !== 'undefined'
            ? {
                onClick: () => {
                    action();
                },
                text: typeof actionLabel !== 'undefined' ? actionLabel : '',
            }
            : undefined,
    });
};
// If intent is danger or success, we want to force a known icon
export const toastIcon = (iconName, intent) => {
    if (intent === 'danger') {
        return 'error';
    }
    else if (intent === 'success') {
        return 'tick';
    }
    else {
        return iconName;
    }
};
export const displayToast = ({ message, intent = Intent.PRIMARY, onAction, actionLabel, onDismiss, timeout = 10000, className = '', iconName, size = 'small', }) => {
    const addClassName = `${cx('client-error', className, `size-${size}`)}`;
    AppToaster.show({
        intent,
        icon: toastIcon(iconName, intent),
        className: addClassName,
        message,
        timeout,
        onDismiss,
        action: typeof onAction !== 'undefined'
            ? {
                onClick: () => {
                    onAction();
                },
                text: typeof actionLabel !== 'undefined' ? actionLabel : '',
            }
            : undefined,
    });
};
//# sourceMappingURL=AppToaster.js.map